import { Controller } from "@hotwired/stimulus";
import Tobii from "@midzer/tobii";

export default class extends Controller {
  connect() {
    this.lightbox = new Tobii({ selector: false });
    this.galleryLinks = this.element.querySelectorAll("a");
    this.galleryLinks.forEach((link) => this.lightbox.add(link));

    document.addEventListener("turbo:before-cache", this.destroyLightbox);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.destroyLightbox);
    this.destroyLightbox();
  }

  destroyLightbox = () => {
    if (!this.lightbox) return;

    if (this.lightbox.isOpen()) this.lightbox.close();
    // Tobii 3.2.0's destroy skips links while removing them from its gallery.
    this.galleryLinks.forEach((link) => this.lightbox.remove(link));
    this.lightbox.destroy();
    this.lightbox = null;
  };
}
